function devtricker_dom_promptFileUpload() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';

    document.body.appendChild(fileInput);

    fileInput.addEventListener('change', async (event) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            const imageUrl = await devtricker_post_uploadImage(file);
            devtricker_dom_setFeaturedImage(imageUrl);
        }

        document.body.removeChild(fileInput);
    });

    fileInput.click();
}

function devtricker_dom_setFeaturedImage(imageUrl) {
    const imageElement = document.createElement('img');
    imageElement.src = imageUrl;
    imageElement.style.width = '100%';

    const container = document.getElementById('devtricker_dom_setFeaturedImage');
    if (container) {
        container.appendChild(imageElement);
    }
}

async function devtricker_post_edit_updateHash() {
    const titleElement = document.querySelector("#johannesEditor .content-wrapper .title h1");
    const contentElement = document.querySelector("#johannesEditor .content-wrapper .content");

    const content = titleElement.textContent.trim() + contentElement.textContent.trim();

    g_post_editor_contentHash = await devtricker_security_hash_calculateHash(content);
}

async function devtricker_post_edit_hasChange() {
    const titleElement = document.querySelector("#johannesEditor .content-wrapper .title h1");
    const contentElement = document.querySelector("#johannesEditor .content-wrapper .content");

    const content = titleElement.textContent.trim() + contentElement.innerHTML.toString().trim();

    const hash = await devtricker_security_hash_calculateHash(content);

    return hash != g_post_editor_contentHash;
}

function devtricker_post_edit_hasContentAndTitle() {
    const titleElement = document.querySelector("#johannesEditor .content-wrapper .title h1");
    const contentElement = document.querySelector("#johannesEditor .content-wrapper .content");

    return titleElement.textContent.trim() != "" && contentElement.textContent.trim();
}

async function devtricker_post_edit_activateButtons() {

    if (devtricker_post_edit_hasContentAndTitle()) {
        const publishButton = document.querySelector("#publishPost");
        publishButton.removeAttribute("disabled");
    } else {
        const publishButton = document.querySelector("#publishPost");
        publishButton.setAttribute("disabled", true);
    }

    if (await devtricker_post_edit_hasChange()) {
        const saveDraftButton = document.getElementById('saveDraftPost');
        saveDraftButton.removeAttribute("disabled");
    } else {
        const saveDraftButton = document.getElementById('saveDraftPost');
        saveDraftButton.setAttribute("disabled", true);
    }

    if (devtricker_post_edit_hasContentAndTitle() && await devtricker_post_edit_hasChange()) {
        const saveAndPublishButton = document.querySelector("#saveAndPublish");
        saveAndPublishButton.removeAttribute("disabled");
    } else {
        const saveAndPublishButton = document.querySelector("#saveAndPublish");
        saveAndPublishButton.setAttribute("disabled", true);
    }
}

function devtricker_post_edit_redirectToEditPage() {
    const postId = devtricker_getThePostId();
    window.location.href = `/post/${postId}/edit/`;
}



function devtricker_contentWrapperToast(toastElement) {
    const offcanvasBody = document.querySelector('.content-wrapper');

    if (offcanvasBody) {
        offcanvasBody.appendChild(toastElement);

        const toast = new bootstrap.Toast(toastElement);
        toast.show();

        setTimeout(() => {
            toastElement.remove();
        }, 2000);
    }
}

if (typeof TextEncoder === 'undefined') {
    class TextEncoder {
        encode(str) {
            const utf8 = unescape(encodeURIComponent(str));
            const result = new Uint8Array(utf8.length);
            for (let i = 0; i < utf8.length; i++) {
                result[i] = utf8.charCodeAt(i);
            }
            return result;
        }
    }
}